import React from 'react';
import PropTypes from 'prop-types';

import { Grid } from '@metarouter-private/mr-mui';

import EventButton from './EventButton';
import EVENT_BUTTONS from './EVENT_BUTTONS';

export default function ActionsCell({ data }) {
  return (
    <Grid container>
      {EVENT_BUTTONS.map(button => (
        <Grid item key={button.dataTestId}>
          <EventButton {...button} eventData={data} />
        </Grid>
      ))}
    </Grid>
  );
}

ActionsCell.propTypes = {
  data: PropTypes.shape({
    inputEvent: PropTypes.string,
    outputEvent: PropTypes.string,
    requestHeaders: PropTypes.string,
    requestBody: PropTypes.string,
    response: PropTypes.string,
  }),
};
